<template>
  <div>
    <md-dialog
      :md-active.sync="dialogActive"
      :md-fullscreen="false"
      class="inquiry new"
      @md-opened="scroll('locked')"
      @md-closed="scroll('clear')"
    >
      <md-dialog-title>お問い合わせ</md-dialog-title>
      <div class="p-4">
        <textarea
          class="form-control"
          rows="6"
          v-model="inquiry"
          placeholder="お問い合わせ内容…"
        />
      </div>
      <md-dialog-actions class="mx-3">
        <button
          type="button"
          class="btn btn-link mr-3"
          @click="closeDialog"
        >
          閉じる
        </button>
        <button
          type="button"
          class="btn btn-success"
          @click="sendMail"
          :disabled="!this.inquiry.length"
        >
          送信
        </button>
      </md-dialog-actions>
    </md-dialog>

    <md-snackbar
      :class="snackbarClass"
      md-position="center"
      :md-active.sync="isSnackbar"
      md-persistent
    >
      <span>{{ snackbarText }}</span>
    </md-snackbar>
  </div>
</template>

<script>
import Mixin from '@/components/mixin/Mixin';
import Const from '@/const';
import Store from '@/store/index.js';

export default {
  name: 'InquiryDialog',
  mixins: [Mixin],
  props: {
    mitumoriData: {
      type: Object,
      required: true,
      // { ID: number, MITUMORI_BANGO: string, STATUS: number }
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    /** お問い合わせテキスト */
    inquiry: '',

    /** スナックバー表示フラグ */
    isSnackbar: false,

    /** スナックバークラス */
    snackbarClass: 'bg-success',

    /** スナックバーテキスト */
    snackbarText: null,
  }),
  computed: {
    dialogActive: {
      get() {
        return this.isActive
      },
      set(value) {
        this.$emit('update:isActive', value)
      },
    },
  },
  methods: {
    /** ダイアログを閉じる */
    closeDialog() {
      this.dialogActive = false
      this.inquiry = ''
    },

    /** 見積メールを送信 */
    async sendMail() {
      this.dialogActive = false
      this.spinerOn()
      let data = {
        id: this.mitumoriData.ID,
        subject: `見積依頼 [${this.mitumoriData.MITUMORI_BANGO}] ${this.torihikiSaki.TORIHIKI_SAKI_MEI} ${this.tantoMei} 様`,
        body: this.inquiry,
      }
      await Store.dispatch('mitumori/send', data)
        .then(() => {
          this.snackbarText = '送信が完了しました'
          this.snackbarClass = 'bg-success'

          let naiyou = '見積お問い合わせ'
          // 履歴更新
          if (this.mitumoriData.STATUS !== Const.status.irai) {
            naiyou += `
ステータス: ${this.getText(this.statusList, Const.status.irai)}`
          }
          this.addRireki({
            MITUMORI_ID: data['id'],
            NAIYOU: naiyou,
            MAIL: data['body'],
          })
          // ステータス更新（ステータスが「依頼」でない場合のみ）
          if (this.mitumoriData.STATUS !== Const.status.irai) {
            this.updateMitumori({ STATUS: Const.status.irai })
          }

          // 成功イベントを発火
          this.$emit('success')
        })
        .catch((err) => {
          this.snackbarText = 'エラーが発生しました code: 403'
          this.snackbarClass = 'bg-danger'
        })
      this.isSnackbar = true
      this.spinerOff()
    },

    /**
     * 見積更新
     * @param  {Json} data 更新データ
     */
    updateMitumori(data) {
      return Store.dispatch(
        'mitumori/edit',
        Object.assign({ ID: this.mitumoriData.ID }, data)
      ).catch((err) => {
        this.snackbarText = 'エラーが発生しました code: 405'
        this.snackbarClass = 'bg-danger'
      })
    },

    /** 履歴データを登録する */
    async addRireki(data) {
      await this.addMitumoriRireki(data)
        .then((result) => {
          // 追加された履歴データを親に返す
          this.$emit('rireki-added', result)
        })
        .catch((err) => {
          this.snackbarText = 'エラーが発生しました code: 404'
          this.snackbarClass = 'bg-danger'
          this.isSnackbar = true
        })
    },
  },
}
</script>

<style lang="sass">
.inquiry.md-dialog
  .md-dialog-container
    width: 95%
    max-width: 700px
</style>




// WEBPACK FOOTER //
// src/components/estimate/InquiryDialog.vue